// 活动相关接口
import request from '@/utils/request'

// 活动详情
export function getActivityDetails(data) {
  return request({
    url: `/cultureCantonDemoApi/activityBasicInfoApi/getActivityDetails?id=${data.id}&userLon=${data.longitude}&userLat=${data.latitude}`,
    method: 'get',
  })
}

// 活动报名接口
export function activitySignUp(data) {
  return request({
    url: `/cultureCantonDemoApi/activityBasicInfoApi/submitActivitySignUp`,
    method: 'post',
    data,
  })
}

// 获取用户信息接口
export function getUserInfo() {
  return request({
    method: 'get',
    url: '/cultureCantonDemoApi/memberBasicInfoApi/getUserInfo',
  })
}
